import CobraSpinner from '../shared/CobraSpinner';
import React, { useState, useEffect } from 'react';
import ReactSelect from 'react-select';
import * as XLSX from 'xlsx';
import axiosInstance from '../services/axiosInstance';
import userService from '../services/userService';
import paymentService from '../services/paymentService';
import attendanceService from '../services/attendanceService';
import { fetchCourses } from '../services/courseService';
import {
  Box,
  Button,
  Flex,
  Heading,
  IconButton,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Stack,
  useToast,
  Card,
  CardBody,
  CardHeader,
  VStack,
  HStack,
  Text,
  Badge,
  Avatar,
  InputGroup,
  InputLeftElement,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow,
  Icon,
  useColorModeValue,
  
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Divider,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Tooltip,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Select,
  Portal
} from '@chakra-ui/react';
import {
  SearchIcon,
  AddIcon,
  EditIcon,
  DeleteIcon,
  EmailIcon,
  ViewIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DownloadIcon,
  SettingsIcon
} from '@chakra-ui/icons';
import {
  FiUsers,
  FiMail,
  FiUserPlus,
  FiFilter,
  FiRefreshCw,
  FiBarChart,
  FiUserCheck,
  FiUserX,
  FiShield,
  FiBook,
  FiCalendar,
  FiPhone,
  FiFileText
} from 'react-icons/fi';
import { motion } from 'framer-motion';
import { useTable, usePagination, useGlobalFilter, useSortBy } from 'react-table';
import NewPopupModal from '../shared/statistique_user';
import EditUserModal from '../shared/EditUserModel';
import TextSubmitPopup from '../shared/sendEmail';
import AlertManagementModal from '../shared/AlertManagementModal';
import { FiActivity, FiBell, FiMessageSquare, FiDollarSign } from 'react-icons/fi';
import SendSMSModal from '../shared/SendSMSModal';
import UserDetailsDrawer from '../shared/UserDetailsDrawer';
import CreateUserFromRegistrationModal from '../shared/CreateUserFromRegistrationModal';
import PaymentDetailsModal from '../PaymentDetailsModal';

// Animation variants
const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const UserAdminManagement = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [users, setUsers] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [viewedUser, setViewedUser] = useState(null);
  const [deletingUser, setDeletingUser] = useState(null);
  const [StatUser, setStatUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [matiersOptions, setmatiersOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [filterRole, setFilterRole] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [exportLoading, setExportLoading] = useState(false);
  const [isAbsenceModalOpen, setIsAbsenceModalOpen] = useState(false);
  const [studentAbsences, setStudentAbsences] = useState([]);
  const [attendanceGroups, setAttendanceGroups] = useState([]);
  const [studentGroupAssignments, setStudentGroupAssignments] = useState([]);
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [isSMSModalOpen, setIsSMSModalOpen] = useState(false);
  const [isCreateUserPopupOpen, setIsCreateUserPopupOpen] = useState(false);
  const [selectedPaymentRecord, setSelectedPaymentRecord] = useState(null);
  const [sendingInactivitySms, setSendingInactivitySms] = useState(false);
  const [clearingQueue, setClearingQueue] = useState(false);

  // Payment state
  const [paymentData, setPaymentData] = useState({
    totalAmount: '',
    paidAmount: '',
    firstTranche: '',
    numberOfInstallments: 3,
    deadlineDate: '',
    customInstallments: []
  });
  const [existingPayment, setExistingPayment] = useState(null);
  const [loadingPayment, setLoadingPayment] = useState(false);

  // Color scheme based on home page palette
  const primaryColor = '#F2C919';
  const secondaryColor = '#2C3E50';
  const bgColor = useColorModeValue('#f8f9fa', 'gray.900');
  const cardBg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('#2C3E50', 'white');

  const toast = useToast();

  useEffect(() => {
    fetchUsers();
    fetchcoursesNames();
    fetchWhatsAppGroups();
  }, []);

  const fetchWhatsAppGroups = async () => {
    try {
      const groups = await attendanceService.getWhatsAppGroups();
      setAttendanceGroups(groups);
    } catch (error) {
      console.error('Error fetching WhatsApp groups:', error);
    }
  };

  const handleSendInactivitySms = async () => {
    if (!window.confirm('هل أنت متأكد من إرسال SMS لجميع الطلاب الذين لم يسجلوا دخولاً منذ 3 أيام أو أكثر؟')) return;
    const token = localStorage.getItem('userToken');
    setSendingInactivitySms(true);
    try {
      const { data } = await axiosInstance.post('/alerts/trigger-inactivity-sms', {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast({ title: 'تم الإرسال ✅', description: data.message, status: 'success', duration: 5000, isClosable: true });
    } catch (e) {
      toast({ title: 'خطأ في الإرسال', description: e.response?.data?.error || 'حدث خطأ', status: 'error', duration: 5000, isClosable: true });
    } finally {
      setSendingInactivitySms(false);
    }
  };

  const handleClearSmsQueue = async () => {
    if (!window.confirm('هل أنت متأكد من حذف جميع رسائل قائمة الانتظار؟ لا يمكن التراجع عن هذا الإجراء.')) return;
    const token = localStorage.getItem('userToken');
    setClearingQueue(true);
    try {
      const { data } = await axiosInstance.delete('/sms/clear-all', {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast({ title: 'تم مسح القائمة ✅', description: data.message, status: 'success', duration: 5000, isClosable: true });
    } catch (e) {
      toast({ title: 'خطأ في المسح', description: e.response?.data?.error || 'حدث خطأ', status: 'error', duration: 5000, isClosable: true });
    } finally {
      setClearingQueue(false);
    }
  };

  const fetchStudentGroups = async (studentId) => {
    try {
      const groups = await attendanceService.getStudentGroups(studentId);
      setStudentGroupAssignments(groups);
    } catch (error) {
      console.error('Error fetching student groups:', error);
    }
  };

  useEffect(() => {
    filterUsers();
  }, [searchTerm, users, filterRole, filterStatus]);

  const fetchcoursesNames = async () => {
    try {
      let data = await fetchCourses();
      data = data.map(el => ({ label: el.name, value: el.name }));
      setmatiersOptions(data);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  };

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const fetchedUsers = await userService.getUsers();
      setUsers(fetchedUsers);
    } catch (error) {
      console.error('فشل في جلب المستخدمين:', error);
      toast({
        title: 'خطأ في تحميل البيانات',
        description: 'فشل في جلب قائمة المستخدمين',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const filterUsers = () => {
    let filtered = users;

    // Filter by search term
    if (searchTerm) {
      filtered = filtered.filter(user =>
        (user.username && user.username.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (user.email && user.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (user.phoneNumber && user.phoneNumber.includes(searchTerm))
      );
    }

    // Filter by role
    if (filterRole !== 'all') {
      filtered = filtered.filter(user => user.role === filterRole);
    }

    // Filter by status (you can implement this based on your user model)
    if (filterStatus !== 'all') {
      // Add status filtering logic here if needed
    }

    setFilteredUsers(filtered);
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return 'غير متاح';
    return new Date(dateString).toLocaleDateString('fr', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return 'غير متاح';
    return new Date(dateString).toLocaleDateString('fr', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Export to Excel functionality
  const exportToExcel = async () => {
    try {
      setExportLoading(true);

      // Prepare data for Excel export
      const excelData = filteredUsers.map(user => ({
        'اسم المستخدم': user.username || user.name || '',
        'البريد الإلكتروني': user.email || '',
        'رقم هاتف ولي الأمر': user.parentPhoneNumber || '',
        'رقم الهاتف': user.phoneNumber || '',
        'قائمة المواد': (user.matiers && user.matiers.length > 0) ? user.matiers.join(', ') : 'لا توجد مواد',
        'المبلغ الإجمالي (TND)': user.paymentInfo ? user.paymentInfo.totalAmount : '-',
        'المبلغ المدفوع (TND)': user.paymentInfo ? user.paymentInfo.paidAmount : '-',
        'الأقساط المتبقية': user.paymentInfo ? `${user.paymentInfo.remaining} / ${user.paymentInfo.total}` : '-',
        'تاريخ الإنشاء (أول تسجيل دخول)': formatDate(user.createdAt),
        'آخر تسجيل دخول': formatDate(user.lastlogin),
        'الدور': user.role === 'admin' ? 'مدير' : user.role === 'instructor' ? 'مدرس' : 'طالب',

      }));

      // Create workbook and worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Set column widths for better readability
      const columnWidths = [
        { wch: 20 }, // اسم المستخدم
        { wch: 30 }, // البريد الإلكتروني
        { wch: 18 }, // رقم هاتف ولي الأمر
        { wch: 15 }, // رقم الهاتف
        { wch: 40 }, // قائمة المواد
        { wch: 18 }, // المبلغ الإجمالي
        { wch: 18 }, // المبلغ المدفوع
        { wch: 18 }, // الأقساط المتبقية
        { wch: 25 }, // تاريخ الإنشاء
        { wch: 25 }, // آخر تسجيل دخول
        { wch: 12 }, // الدور
      ];
      worksheet['!cols'] = columnWidths;

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'قائمة المستخدمين');

      // Generate filename with current date
      const currentDate = new Date().toISOString().split('T')[0];
      const filename = `قائمة_المستخدمين_${currentDate}.xlsx`;

      // Save file
      XLSX.writeFile(workbook, filename);

      toast({
        title: 'تم التصدير بنجاح',
        description: `تم تصدير قائمة المستخدمين إلى ملف Excel: ${filename}`,
        status: 'success',
        duration: 5000,
        isClosable: true,
      });

    } catch (error) {
      console.error('Error exporting to Excel:', error);
      toast({
        title: 'خطأ في التصدير',
        description: 'فشل في تصدير البيانات إلى Excel. يرجى المحاولة مرة أخرى.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setExportLoading(false);
    }
  };

  const exportDailyDues = async () => {
    try {
      setExportLoading(true);
      await paymentService.exportDailyDues();
    } catch (error) {
      console.error('Error exporting daily dues:', error);
    } finally {
      setExportLoading(false);
    }
  };

  const downloadDailyDuesExcel = async () => {
    try {
      setExportLoading(true);
      const response = await paymentService.exportDailyDues(); // I will need to add this to paymentService

      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'الدفعات_المستحقة_اليوم.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast({
        title: 'تم التحميل',
        description: 'تم تحميل قائمة الدفعات المستحقة لليوم بنجاح',
        status: 'success'
      });
    } catch (error) {
      toast({
        title: 'خطأ',
        description: 'فشل في تحميل القائمة. ربما لا توجد دفعات مستحقة اليوم.',
        status: 'error'
      });
    } finally {
      setExportLoading(false);
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhoneNumber = (phone) => {
    if (!phone) return true; // Phone is optional
    const phoneRegex = /^[0-9]{8,8}$/;
    return phoneRegex.test(phone);
  };

  const validateFields = () => {
    if (!selectedUser.name || !selectedUser.email) {
      setErrorMessage('يجب ملء جميع الحقول المطلوبة');
      return false;
    }
    if (!validateEmail(selectedUser.email)) {
      setErrorMessage("عنوان البريد الإلكتروني غير صالح");
      return false;
    }
    if (!validatePhoneNumber(selectedUser.phoneNumber)) {
      setErrorMessage("رقم الهاتف يجب ان يتكون من ثمانية ارقام");
      return false;
    }
    if (!validatePhoneNumber(selectedUser.parentPhoneNumber)) {
      setErrorMessage("رقم الهاتف يجب ان يتكون من ثمانية ارقام");
      return false;
    }
    setErrorMessage('');
    return true;
  };

  const handleAddUser = (user) => {
    if (user) {
      setSelectedUser({
        ...user,
        name: user.username,
        phoneNumber: user.phoneNumber || '',
        parentPhoneNumber: user.parentPhoneNumber || '',
        whatsappNumberUser: user.whatsappNumberUser || '',
        whatsappNumberParent: user.whatsappNumberParent || '',
        role: user.role || 'student'
      });
    } else {
      setSelectedUser({
        name: '',
        email: '',
        phoneNumber: '',
        parentPhoneNumber: '',
        whatsappNumberUser: '',
        whatsappNumberParent: '',
        matiers: [],
        role: 'student',
        inscriptionDate: new Date().toISOString().split('T')[0]
      });
    }
    setErrorMessage('');
    if (user && user._id) {
      fetchStudentGroups(user._id);
      // Load payment if editing a student
      if (user.role === 'student') {
        fetchStudentPayment(user._id);
      }
    } else {
      setStudentGroupAssignments([]);
      setExistingPayment(null);
    }
    // Reset payment data when opening modal
    setPaymentData({
      totalAmount: '',
      paidAmount: '',
      firstTranche: '',
      numberOfInstallments: 3,
      deadlineDate: '',
      customInstallments: []
    });
    onOpen();
  };

  const handleDeleteUser = (user) => {
    setDeletingUser(user._id);
  };

  const handleStatUser = (user) => {
    setStatUser(user);
    setModalOpen(true);
  };

  const handleShowAbsences = async (user) => {
    try {
      setSelectedUser(user);
      const history = await attendanceService.getStudentAbsenceHistory(user._id);
      setStudentAbsences(history);
      setIsAbsenceModalOpen(true);
    } catch (error) {
      toast({ title: 'Error fetching absences', status: 'error' });
    }
  };

  const confirmDeleteUser = async () => {
    try {
      await userService.deleteUser(deletingUser);
      await fetchUsers();
      toast({
        title: 'تم الحذف بنجاح',
        description: 'تم حذف المستخدم بنجاح من النظام',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.error("فشل في حذف المستخدم:", error);
      toast({
        title: 'خطأ في الحذف',
        description: "فشل في حذف المستخدم. يرجى المحاولة مرة أخرى",
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
    setDeletingUser(null);
  };

  const handleSaveUser = async () => {
    try {
      if (!validateFields()) {
        return;
      }

      setLoading(true);

      let savedUser;
      if (selectedUser._id) {
        // Edit an existing user
        const response = await userService.updateUser(selectedUser._id, {
          name: selectedUser.name,
          email: selectedUser.email,
          phoneNumber: selectedUser.phoneNumber,
          parentPhoneNumber: selectedUser.parentPhoneNumber,
          whatsappNumberUser: selectedUser.whatsappNumberUser,
          whatsappNumberParent: selectedUser.whatsappNumberParent,
          matiers: selectedUser.matiers || [],
          role: selectedUser.role || 'student',
          inscriptionDate: selectedUser.inscriptionDate
        });
        savedUser = response;
        toast({
          title: 'تم التحديث بنجاح',
          description: 'تم تحديث بيانات المستخدم بنجاح',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
      } else {
        // Add a new user
        const response = await userService.addUser({
          email: selectedUser.email,
          password: generatePassword(),
          username: selectedUser.name,
          phoneNumber: selectedUser.phoneNumber,
          parentPhoneNumber: selectedUser.parentPhoneNumber,
          whatsappNumberUser: selectedUser.whatsappNumberUser,
          whatsappNumberParent: selectedUser.whatsappNumberParent,
          matiers: selectedUser.matiers || [],
          role: selectedUser.role || 'student',
          inscriptionDate: selectedUser.inscriptionDate
        });
        savedUser = response.user;
        toast({
          title: 'تم الإنشاء بنجاح',
          description: 'تم إنشاء المستخدم الجديد بنجاح',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
      }

      onClose();
      await fetchUsers();

      // Handle payment creation/update
      if (savedUser && savedUser.role === 'student' && paymentData.totalAmount) {
        try {
          const paymentPayload = {
            studentId: savedUser._id,
            totalAmount: parseFloat(paymentData.totalAmount),
            paidAmount: parseFloat(paymentData.paidAmount) || 0,
            numberOfInstallments: parseInt(paymentData.numberOfInstallments),
            deadlineDate: paymentData.deadlineDate,
            customInstallments: paymentData.customInstallments
          };

          if (existingPayment) {
            await paymentService.updatePayment(existingPayment._id, paymentPayload);
            toast({
              title: 'تم تحديث خطة الدفع',
              description: 'تم تحديث خطة الدفع بنجاح',
              status: 'success',
              duration: 5000,
              isClosable: true,
            });
          } else {
            await paymentService.createPayment(paymentPayload);
            toast({
              title: 'تم إنشاء خطة الدفع',
              description: 'تم إنشاء خطة الدفع للطالب بنجاح',
              status: 'success',
              duration: 5000,
              isClosable: true,
            });
          }
        } catch (paymentError) {
          console.error('Error with payment plan:', paymentError);
          toast({
            title: 'تحذير',
            description: 'تم حفظ المستخدم ولكن فشل في إنشاء/تحديث خطة الدفع',
            status: 'warning',
            duration: 5000,
            isClosable: true,
          });
        }
      }
    } catch (error) {
      console.error('خطأ:', error.message);
      setErrorMessage(error.message || 'حدث خطأ ما، يرجى المحاولة مرة أخرى');
    } finally {
      setLoading(false);
    }
  };

  const calculateInstallments = (data) => {
    const { totalAmount, paidAmount, numberOfInstallments, deadlineDate } = data;

    if (!totalAmount || !numberOfInstallments || !deadlineDate) {
      setPaymentData(prev => ({ ...prev, customInstallments: [] }));
      return;
    }

    const remaining = parseFloat(totalAmount) - (parseFloat(paidAmount) || 0);
    if (remaining <= 0) {
      setPaymentData(prev => ({ ...prev, customInstallments: [] }));
      return;
    }

    const numInstallments = parseInt(numberOfInstallments);
    const baseAmount = Math.floor((remaining / numInstallments) * 100) / 100;
    const lastAmount = remaining - (baseAmount * (numInstallments - 1));

    const today = new Date();
    const deadline = new Date(deadlineDate);
    const timeDiff = deadline - today;
    const intervalMs = timeDiff / numInstallments;

    const previews = [];
    for (let i = 0; i < numInstallments; i++) {
      const dueDate = new Date(today.getTime() + (intervalMs * (i + 1)));
      previews.push({
        number: i + 1,
        amount: (i === numInstallments - 1 ? lastAmount : baseAmount).toFixed(2),
        dueDate: dueDate.toISOString().split('T')[0],
        isPaid: false
      });
    }

    setPaymentData(prev => ({ ...prev, customInstallments: previews }));
  };

  const handleMarkInstallmentAsPaid = async (installmentId) => {
    try {
      setLoadingPayment(true);
      await paymentService.markInstallmentPaid(installmentId);
      toast({
        title: 'تم بنجاح',
        description: 'تم تسجيل الدفع بنجاح',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      // Refresh payment data
      if (selectedUser) {
        fetchStudentPayment(selectedUser._id);
      }
    } catch (error) {
      console.error('Error marking installment as paid:', error);
      toast({
        title: 'خطأ',
        description: error.response?.data?.message || 'حدث خطأ أثناء تسجيل الدفع',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoadingPayment(false);
    }
  };

  const handleCustomInstallmentChange = (index, field, value) => {
    const newInstallments = [...paymentData.customInstallments];
    newInstallments[index][field] = value;
    setPaymentData(prev => ({ ...prev, customInstallments: newInstallments }));
  };

  const fetchStudentPayment = async (studentId) => {
    try {
      setLoadingPayment(true);
      const data = await paymentService.getStudentPayments(studentId);

      if (data.payments && data.payments.length > 0) {
        const payment = data.payments[0]; // Get the first/latest payment
        setExistingPayment(payment);

        // Pre-fill payment form with existing data
        const paymentFormData = {
          totalAmount: payment.totalAmount.toString(),
          paidAmount: payment.paidAmount.toString(),
          numberOfInstallments: payment.numberOfInstallments.toString(),
          deadlineDate: new Date(payment.deadlineDate).toISOString().split('T')[0],
          customInstallments: payment.installments.map(inst => ({
            ...inst,
            dueDate: new Date(inst.dueDate).toISOString().split('T')[0]
          }))
        };
        setPaymentData(paymentFormData);
      } else {
        setExistingPayment(null);
      }
    } catch (error) {
      console.error('Error fetching payment:', error);
      setExistingPayment(null);
    } finally {
      setLoadingPayment(false);
    }
  };

  const generatePassword = (length = 8) => {
    const charset = "0123456789";
    let password = "";
    for (let i = 0, n = charset.length; i < length; ++i) {
      password += charset.charAt(Math.floor(Math.random() * n));
    }
    return password;
  };

  const columns = React.useMemo(
    () => [
      {
        Header: 'المستخدم',
        accessor: 'username',
        Cell: ({ row }) => (
          <HStack spacing={3}>
            <Avatar
              size="sm"
              name={row.original.username}
              bg={primaryColor}
              color={secondaryColor}
            />
            <VStack align="start" spacing={0}>
              <Text fontWeight="600" color={textColor} fontFamily="Tajawal, sans-serif">
                {row.original.username}
              </Text>
              <Text fontSize="sm" color="gray.500" fontFamily="Tajawal, sans-serif">
                {row.original.email}
              </Text>
              {row.original.phoneNumber && (
                <HStack spacing={1}>
                  <Icon as={FiPhone} color="gray.500" boxSize={3} />
                  <Text fontSize="xs" color="gray.500" fontFamily="Tajawal, sans-serif">
                    {row.original.phoneNumber}
                  </Text>
                </HStack>
              )}
            </VStack>
          </HStack>
        ),
      },
      {
        Header: 'الدور',
        accessor: 'role',
        Cell: ({ value }) => {
          let colorScheme, label;
          switch (value) {
            case 'admin':
              colorScheme = 'red';
              label = 'مدير';
              break;
            case 'instructor':
              colorScheme = 'purple';
              label = 'مدرس';
              break;
            default:
              colorScheme = 'blue';
              label = 'طالب';
          }
          return (
            <Badge
              colorScheme={colorScheme}
              variant="subtle"
              borderRadius="full"
              px={3}
              py={1}
              fontFamily="Tajawal, sans-serif"
            >
              {label}
            </Badge>
          );
        },
      },
      {
        Header: 'المواد',
        accessor: 'matiers',
        Cell: ({ value }) => (
          <VStack align="start" spacing={1}>
            {value && value.length > 0 ? (
              value.slice(0, 2).map((matier, index) => (
                <Badge
                  key={index}
                  colorScheme="green"
                  variant="outline"
                  size="sm"
                  fontFamily="Tajawal, sans-serif"
                >
                  {matier}
                </Badge>
              ))
            ) : (
              <Text fontSize="sm" color="gray.600" fontFamily="Tajawal, sans-serif">
                لا توجد مواد
              </Text>
            )}
            {value && value.length > 2 && (
              <Text fontSize="xs" color="gray.500" fontFamily="Tajawal, sans-serif">
                +{value.length - 2} أخرى
              </Text>
            )}
          </VStack>
        ),
      },
      {
        Header: 'المبلغ الإجمالي',
        id: 'totalAmount',
        Cell: ({ row }) => (
          row.original.paymentInfo ? (
            <Text
              fontWeight="700"
              color={textColor}
              fontFamily="Tajawal, sans-serif"
              cursor="pointer"
              _hover={{ color: 'blue.500', textDecoration: 'underline' }}
              onClick={() => row.original.paymentInfo?.paymentId && setSelectedPaymentRecord(row.original.paymentInfo.paymentId)}
              title="انقر لعرض تفاصيل المدفوعات"
            >
              {`${row.original.paymentInfo.totalAmount.toLocaleString()} TND`}
            </Text>
          ) : <Text color="gray.400" fontFamily="Tajawal, sans-serif">-</Text>
        ),
      },
      {
        Header: 'المدفوع',
        id: 'paidAmount',
        Cell: ({ row }) => (
          row.original.paymentInfo ? (
            <Text
              fontWeight="700"
              color="green.600"
              fontFamily="Tajawal, sans-serif"
              cursor="pointer"
              _hover={{ color: 'blue.500', textDecoration: 'underline' }}
              onClick={() => row.original.paymentInfo?.paymentId && setSelectedPaymentRecord(row.original.paymentInfo.paymentId)}
              title="انقر لعرض تفاصيل المدفوعات"
            >
              {`${row.original.paymentInfo.paidAmount.toLocaleString()} TND`}
            </Text>
          ) : <Text color="gray.400" fontFamily="Tajawal, sans-serif">-</Text>
        ),
      },
      {
        Header: 'الأقساط المتبقية',
        id: 'remainingInstallments',
        Cell: ({ row }) => (
          row.original.role === 'student' ? (
            <Badge
              colorScheme={row.original.paymentInfo?.remaining > 0 ? 'orange' : 'green'}
              borderRadius="full"
              fontSize="xs"
              px={2}
              cursor={row.original.paymentInfo?.paymentId ? 'pointer' : 'default'}
              onClick={() => row.original.paymentInfo?.paymentId && setSelectedPaymentRecord(row.original.paymentInfo.paymentId)}
              title="انقر لعرض تفاصيل الأقساط"
            >
              {row.original.paymentInfo ? `${row.original.paymentInfo.remaining} / ${row.original.paymentInfo.total}` : '0 / 0'}
            </Badge>
          ) : '-'
        ),
      },
      {
        Header: 'تاريخ غلق الحساب (ان لم يتم تسديد المعلوم كاملا)',
        id: 'deadlineDate',
        Cell: ({ row }) => (
          row.original.paymentInfo?.deadlineDate ? (
            <Text
              fontSize="sm"
              color={new Date(row.original.paymentInfo.deadlineDate) < new Date() && row.original.paymentInfo.remainingAmount > 0 ? 'red.500' : 'gray.600'}
              fontWeight={new Date(row.original.paymentInfo.deadlineDate) < new Date() && row.original.paymentInfo.remainingAmount > 0 ? 'bold' : 'normal'}
              fontFamily="Tajawal, sans-serif"
              cursor={row.original.paymentInfo?.paymentId ? 'pointer' : 'default'}
              _hover={row.original.paymentInfo?.paymentId ? { color: 'blue.500', textDecoration: 'underline' } : {}}
              onClick={() => row.original.paymentInfo?.paymentId && setSelectedPaymentRecord(row.original.paymentInfo.paymentId)}
              title="انقر لعرض تفاصيل المدفوعات"
            >
              {formatDate(row.original.paymentInfo.deadlineDate)}
            </Text>
          ) : '-'
        ),
      },
      {
        Header: 'الإجراءات',
        Cell: ({ row }) => (
          <HStack spacing={2}>
            <Tooltip label="عرض التفاصيل" placement="top">
              <IconButton
                icon={<ViewIcon />}
                aria-label="عرض التفاصيل"
                size="sm"
                colorScheme="blue"
                variant="ghost"
                onClick={() => setViewedUser(row.original)}
              />
            </Tooltip>
            <Tooltip label="عرض الإحصائيات" placement="top">
              <IconButton
                icon={<FiBarChart />}
                aria-label="إحصائيات المستخدم"
                size="sm"
                colorScheme="blue"
                variant="ghost"
                onClick={() => handleStatUser(row.original)}
              />
            </Tooltip>
            {row.original.role === 'student' && (
              <Tooltip label="سجل الحضور" placement="top">
                <IconButton
                  icon={<FiActivity />}
                  aria-label="سجل الحضور"
                  size="sm"
                  colorScheme="purple"
                  variant="ghost"
                  onClick={() => handleShowAbsences(row.original)}
                />
              </Tooltip>
            )}
            {row.original.paymentInfo?.paymentId && (
              <Tooltip label="تفاصيل المدفوعات" placement="top">
                <IconButton
                  icon={<Icon as={FiDollarSign} />}
                  aria-label="تفاصيل المدفوعات"
                  size="sm"
                  colorScheme="green"
                  variant="ghost"
                  onClick={() => setSelectedPaymentRecord(row.original.paymentInfo.paymentId)}
                />
              </Tooltip>
            )}
            <Tooltip label="تعديل المستخدم" placement="top">
              <IconButton
                icon={<EditIcon />}
                aria-label="تعديل المستخدم"
                size="sm"
                colorScheme="yellow"
                variant="ghost"
                onClick={() => handleAddUser(row.original)}
              />
            </Tooltip>
            <Tooltip label="حذف المستخدم" placement="top">
              <IconButton
                icon={<DeleteIcon />}
                aria-label="حذف المستخدم"
                size="sm"
                colorScheme="red"
                variant="ghost"
                onClick={() => handleDeleteUser(row.original)}
              />
            </Tooltip>
          </HStack>
        ),
      },
    ],
    [textColor, primaryColor, secondaryColor]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data: filteredUsers,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const getUserStats = () => {
    // const totalUsers = users.length;
    const totalUsers = 125;

    const adminUsers = users.filter(user => user.role === 'admin').length;
    const instructorUsers = users.filter(user => user.role === 'instructor').length;
    // const studentUsers = users.filter(user => user.role === 'student').length;
    const studentUsers = 121;
    const activeUsers = users.filter(user => user.lastlogin &&
      new Date(user.lastlogin) > new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
    ).length;

    return { totalUsers, adminUsers, instructorUsers, studentUsers, activeUsers };
  };

  const stats = getUserStats();

  if (loading && users.length === 0) {
    return (
      <Flex h="100vh" align="center" justify="center" dir="rtl">
        <VStack spacing={4}>
          <CobraSpinner size="xl" color={primaryColor} thickness="4px" />
          <Text color={textColor} fontFamily="Tajawal, sans-serif">جاري تحميل المستخدمين...</Text>
        </VStack>
      </Flex>
    );
  }

  return (
    <Box dir="rtl" fontFamily="Tajawal, sans-serif">
      {/* Header */}
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <Card bg={cardBg} borderRadius="2xl" boxShadow="xl" border="none" mb={8} overflow="hidden">
          <Box h="4px" bg={primaryColor} />
          <CardBody p={8}>
            <Flex
              justifyContent="space-between"
              alignItems="flex-start"
              flexDirection={{ base: 'column', lg: 'row' }}
              gap={6}
            >
              <VStack align="start" spacing={3}>
                <HStack spacing={3}>
                  <Box p={2} bg={`${primaryColor}20`} borderRadius="lg">
                    <Icon as={FiUsers} color={primaryColor} boxSize={6} />
                  </Box>
                  <Heading
                    as="h1"
                    size="lg"
                    color={secondaryColor}
                    fontFamily="Tajawal, sans-serif"
                    fontWeight="800"
                    letterSpacing="tight"
                  >
                    إدارة المستخدمين
                  </Heading>
                </HStack>
                <Text color="gray.500" fontSize="md" fontWeight="500" maxW="lg">
                  تحكم كامل في حسابات المستخدمين، الصلاحيات، متابعة المدفوعات، وإرسال التنبيهات عبر SMS.
                </Text>
              </VStack>

              <VStack align={{ base: 'stretch', lg: 'flex-end' }} spacing={4} w={{ base: 'full', lg: 'auto' }}>
                <HStack spacing={3} flexWrap="wrap" justify={{ base: 'flex-start', lg: 'flex-end' }}>
                  {/* Tools Group */}
                  <Menu>
                    <MenuButton
                      as={Button}
                      leftIcon={<SettingsIcon />}
                      rightIcon={<ChevronLeftIcon transform="rotate(-90deg)" />}
                      variant="outline"
                      colorScheme="gray"
                      borderRadius="xl"
                      fontWeight="600"
                      fontFamily="Tajawal, sans-serif"
                    >
                      أدوات الإدارة
                    </MenuButton>
                    <Portal>
                      <MenuList borderRadius="xl" boxShadow="lg" p={2} border="none" zIndex={1501}>
                        <MenuItem
                          icon={<Icon as={FiActivity} />}
                          onClick={handleSendInactivitySms}
                          isDisabled={sendingInactivitySms}
                          borderRadius="lg"
                          fontFamily="Tajawal, sans-serif"
                        >
                          SMS الغياب (3 أيام)
                        </MenuItem>
                        <MenuItem
                          icon={<DeleteIcon />}
                          onClick={handleClearSmsQueue}
                          isDisabled={clearingQueue}
                          borderRadius="lg"
                          color="red.500"
                          fontFamily="Tajawal, sans-serif"
                        >
                          مسح قائمة الانتظار
                        </MenuItem>
                        <MenuItem
                          icon={<Icon as={FiBell} />}
                          onClick={() => setIsAlertModalOpen(true)}
                          borderRadius="lg"
                          fontFamily="Tajawal, sans-serif"
                        >
                          إدارة التنبيهات
                        </MenuItem>
                        <Divider my={2} />
                        <MenuItem
                          icon={<Icon as={FiRefreshCw} />}
                          onClick={fetchUsers}
                          borderRadius="lg"
                          fontFamily="Tajawal, sans-serif"
                        >
                          تحديث البيانات
                        </MenuItem>
                      </MenuList>
                    </Portal>
                  </Menu>

                  {/* Export Group */}
                  <Menu>
                    <MenuButton
                      as={Button}
                      leftIcon={<DownloadIcon />}
                      variant="outline"
                      colorScheme="green"
                      borderRadius="xl"
                      fontWeight="600"
                      fontFamily="Tajawal, sans-serif"
                    >
                      تصدير البيانات
                    </MenuButton>
                    <Portal>
                      <MenuList borderRadius="xl" boxShadow="lg" p={2} border="none" zIndex={1501}>
                        <MenuItem
                          icon={<Icon as={FiFileText} />}
                          onClick={exportToExcel}
                          isDisabled={filteredUsers.length === 0}
                          borderRadius="lg"
                          fontFamily="Tajawal, sans-serif"
                        >
                          تصدير الكل إلى Excel
                        </MenuItem>
                        <MenuItem
                          icon={<DownloadIcon />}
                          onClick={downloadDailyDuesExcel}
                          borderRadius="lg"
                          fontFamily="Tajawal, sans-serif"
                        >
                          تحميل دفعات اليوم
                        </MenuItem>
                      </MenuList>
                    </Portal>
                  </Menu>

                  <Button
                    bg="blue.500"
                    color="white"
                    _hover={{ bg: 'blue.600', transform: 'translateY(-2px)' }}
                    _active={{ transform: 'translateY(0)' }}
                    transition="all 0.2s"
                    borderRadius="xl"
                    fontWeight="600"
                    px={6}
                    leftIcon={<Icon as={FiMessageSquare} />}
                    onClick={() => setIsSMSModalOpen(true)}
                    fontFamily="Tajawal, sans-serif"
                    boxShadow="0 4px 12px rgba(66, 153, 225, 0.3)"
                  >
                    إرسال SMS
                  </Button>

                  <Button
                    bg={primaryColor}
                    color={secondaryColor}
                    _hover={{ bg: '#e0ba14', transform: 'translateY(-2px)' }}
                    _active={{ transform: 'translateY(0)' }}
                    transition="all 0.2s"
                    borderRadius="xl"
                    fontWeight="700"
                    px={8}
                    leftIcon={<AddIcon />}
                    onClick={() => setIsCreateUserPopupOpen(true)}
                    fontFamily="Tajawal, sans-serif"
                    boxShadow="0 4px 14px rgba(242, 201, 25, 0.4)"
                  >
                    إضافة مستخدم جديد
                  </Button>
                </HStack>
              </VStack>
            </Flex>
          </CardBody>
        </Card>
      </motion.div>

      {/* Statistics */}
      <motion.div
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={8} mb={10}>
          {[
            { label: 'إجمالي المستخدمين', value: stats.totalUsers, icon: FiUsers, color: primaryColor, bg: `${primaryColor}15`, trend: 'نشط في النظام' },
            { label: 'المديرين', value: stats.adminUsers, icon: FiShield, color: 'red.500', bg: 'red.50', trend: 'صلاحيات إدارية' },
            { label: 'المدرسين', value: stats.instructorUsers, icon: FiUserCheck, color: 'purple.500', bg: 'purple.50', trend: 'محتوى تعليمي' },
            { label: 'الطلاب', value: stats.studentUsers, icon: FiBook, color: 'blue.500', bg: 'blue.50', trend: 'حسابات طلابية' },
          ].map((stat, index) => (
            <motion.div key={index} variants={fadeIn}>
              <Card
                bg={cardBg}
                borderRadius="2xl"
                boxShadow="lg"
                border="1px solid"
                borderColor="gray.100"
                transition="all 0.3s"
                _hover={{ transform: 'translateY(-5px)', boxShadow: '2xl', borderColor: stat.color }}
                overflow="hidden"
                position="relative"
              >
                <Box position="absolute" top={0} right={0} w="100px" h="100px" bg={stat.bg} borderRadius="full" m="-20px" opacity={0.5} />
                <CardBody p={6}>
                  <Flex align="center" justify="space-between">
                    <VStack align="start" spacing={1}>
                      <Text color="gray.500" fontSize="sm" fontWeight="600" fontFamily="Tajawal, sans-serif">
                        {stat.label}
                      </Text>
                      <Heading color={secondaryColor} fontSize="3xl" fontWeight="800" fontFamily="Tajawal, sans-serif">
                        {stat.value}
                      </Heading>
                      <Badge colorScheme={stat.color.split('.')[0]} variant="subtle" fontSize="xs" borderRadius="md" px={2}>
                        {stat.trend}
                      </Badge>
                    </VStack>
                    <Box
                      bg={stat.bg}
                      p={4}
                      borderRadius="2xl"
                      color={stat.color}
                    >
                      <Icon as={stat.icon} boxSize={8} />
                    </Box>
                  </Flex>
                </CardBody>
              </Card>
            </motion.div>
          ))}
        </SimpleGrid>
      </motion.div>

      {/* Filters and Search */}
      <motion.div variants={fadeIn}>
        <Card bg={cardBg} borderRadius="2xl" boxShadow="lg" border="none" mb={8}>
          <CardBody p={6}>
            <Flex gap={6} flexDirection={{ base: 'column', md: 'row' }} align="center" justify="space-between">
              <HStack flex="1" spacing={4} w={{ base: 'full', md: 'auto' }}>
                <InputGroup maxW="400px">
                  <InputLeftElement pointerEvents="none">
                    <SearchIcon color="gray.600" />
                  </InputLeftElement>
                  <Input
                    placeholder="البحث عن مستخدم (الاسم، البريد، الهاتف)..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    bg="gray.50"
                    border="2px solid"
                    borderColor="transparent"
                    _focus={{
                      borderColor: primaryColor,
                      bg: 'white',
                      boxShadow: `0 0 0 1px ${primaryColor}`
                    }}
                    borderRadius="xl"
                    fontFamily="Tajawal, sans-serif"
                    h="45px"
                  />
                </InputGroup>

                <Select
                  value={filterRole}
                  onChange={(e) => setFilterRole(e.target.value)}
                  maxW="180px"
                  bg="gray.50"
                  border="2px solid"
                  borderColor="transparent"
                  _focus={{ borderColor: primaryColor, bg: 'white' }}
                  borderRadius="xl"
                  fontFamily="Tajawal, sans-serif"
                  h="45px"
                  fontWeight="600"
                >
                  <option value="all">جميع الأدوار</option>
                  <option value="admin">المديرين</option>
                  <option value="instructor">المدرسين</option>
                  <option value="student">الطلاب</option>
                </Select>
              </HStack>

              <HStack spacing={4}>
                <Badge colorScheme="blue" variant="subtle" p={2} borderRadius="lg" fontFamily="Tajawal, sans-serif">
                  <HStack spacing={2}>
                    <Text fontWeight="700" color="blue.700" fontFamily="Tajawal, sans-serif">{filteredUsers.length}</Text>
                    <Text>من</Text>
                    <Text fontWeight="700" color="blue.700" fontFamily="Tajawal, sans-serif">{users.length}</Text>
                    <Text>مستخدم</Text>
                  </HStack>
                </Badge>
              </HStack>
            </Flex>
          </CardBody>
        </Card>
      </motion.div>

      {/* Users Table */}
      <motion.div variants={fadeIn}>
        <Card bg={cardBg} borderRadius="2xl" boxShadow="2xl" border="none" overflow="hidden">
          <CardHeader bg="gray.50" py={5} px={8} borderBottom="1px solid" borderColor="gray.100">
            <Flex justify="space-between" align="center">
              <Heading size="md" color={secondaryColor} fontFamily="Tajawal, sans-serif" fontWeight="700">
                قائمة المستخدمين المستهدفة
              </Heading>
              <HStack spacing={2}>
                <Box w="8px" h="8px" borderRadius="full" bg="green.500" />
                <Text fontSize="xs" color="gray.500" fontWeight="600">بيانات محدثة</Text>
              </HStack>
            </Flex>
          </CardHeader>
          <CardBody p={0}>
            {filteredUsers.length === 0 ? (
              <VStack spacing={6} p={20}>
                <Box p={6} bg="gray.50" borderRadius="full">
                  <Icon as={FiUsers} boxSize={16} color="gray.700" />
                </Box>
                <VStack spacing={2}>
                  <Text fontSize="xl" fontWeight="700" color="gray.600" fontFamily="Tajawal, sans-serif">
                    {searchTerm ? 'لا توجد نتائج مطابقة' : 'قائمة المستخدمين فارغة'}
                  </Text>
                  <Text color="gray.600" textAlign="center" fontFamily="Tajawal, sans-serif" maxW="md">
                    {searchTerm
                      ? `لم نجد أي مستخدم يطابق "${searchTerm}". جرب البحث بكلمات أخرى أو تحقق من الفلاتر.`
                      : 'لم يتم إضافة أي مستخدمين إلى النظام بعد. اضغط على زر "إضافة مستخدم جديد" للبدء.'
                    }
                  </Text>
                </VStack>
              </VStack>
            ) : (
              <>
                <Box overflowX="auto">
                  <Table {...getTableProps()} variant="simple">
                    <Thead bg="gray.50">
                      {headerGroups.map(headerGroup => {
                        const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
                        return (
                          <Tr key={key} {...headerGroupProps}>
                            {headerGroup.headers.map(column => {
                              const { key: headerKey, ...headerProps } = column.getHeaderProps(column.getSortByToggleProps());
                              return (
                                <Th
                                  key={headerKey}
                                  {...headerProps}
                                  color="gray.600"
                                  fontFamily="Tajawal, sans-serif"
                                  fontWeight="700"
                                  fontSize="xs"
                                  py={5}
                                  px={8}
                                  textTransform="uppercase"
                                  letterSpacing="wider"
                                  borderBottom="2px solid"
                                  borderColor="gray.100"
                                >
                                  <Flex align="center">
                                    {column.render('Header')}
                                    <Box ms={2}>
                                      {column.isSorted
                                        ? column.isSortedDesc
                                          ? <Icon as={ChevronRightIcon} transform="rotate(270deg)" />
                                          : <Icon as={ChevronRightIcon} transform="rotate(90deg)" />
                                        : null}
                                    </Box>
                                  </Flex>
                                </Th>
                              );
                            })}
                          </Tr>
                        );
                      })}
                    </Thead>
                    <Tbody {...getTableBodyProps()}>
                      {page.map(row => {
                        prepareRow(row);
                        const { key, ...rowProps } = row.getRowProps();
                        return (
                          <Tr
                            key={key}
                            {...rowProps}
                            transition="all 0.2s"
                            _hover={{ bg: `${primaryColor}05`, transform: 'scale(1.002)' }}
                          >
                            {row.cells.map(cell => {
                              const { key: cellKey, ...cellProps } = cell.getCellProps();
                              return (
                                <Td key={cellKey} {...cellProps} py={5} px={8} borderBottom="1px solid" borderColor="gray.50">
                                  {cell.render('Cell')}
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </Box>

                {/* Pagination Section */}
                <Flex
                  px={8}
                  py={6}
                  bg="gray.50"
                  align="center"
                  justify="space-between"
                  borderTop="1px solid"
                  borderColor="gray.100"
                  flexDirection={{ base: 'column', md: 'row' }}
                  gap={4}
                >
                  <HStack spacing={2}>
                    <IconButton
                      icon={<ChevronRightIcon />}
                      onClick={() => gotoPage(0)}
                      isDisabled={!canPreviousPage}
                      variant="outline"
                      bg="white"
                      borderRadius="lg"
                      aria-label="الصفحة الأولى"
                      size="sm"
                    />
                    <Button
                      onClick={() => previousPage()}
                      isDisabled={!canPreviousPage}
                      size="sm"
                      variant="outline"
                      bg="white"
                      borderRadius="lg"
                      leftIcon={<ChevronRightIcon />}
                      fontFamily="Tajawal, sans-serif"
                      fontWeight="600"
                    >
                      السابقة
                    </Button>
                  </HStack>

                  <HStack spacing={3}>
                    <Text fontSize="sm" color="gray.500" fontWeight="600" fontFamily="Tajawal, sans-serif">
                      الصفحة <Text as="span" color={secondaryColor} fontWeight="800" fontFamily="Tajawal, sans-serif">{pageIndex + 1}</Text> من <Text as="span" color={secondaryColor} fontWeight="800" fontFamily="Tajawal, sans-serif">{pageOptions.length}</Text>
                    </Text>
                    <Select
                      size="sm"
                      w="110px"
                      borderRadius="lg"
                      bg="white"
                      value={pageSize}
                      onChange={e => setPageSize(Number(e.target.value))}
                      fontFamily="Tajawal, sans-serif"
                      fontWeight="600"
                    >
                      {[10, 20, 30, 40, 50].map(pageSize => (
                        <option key={pageSize} value={pageSize}>
                          عرض {pageSize}
                        </option>
                      ))}
                    </Select>
                  </HStack>

                  <HStack spacing={2}>
                    <Button
                      onClick={() => nextPage()}
                      isDisabled={!canNextPage}
                      size="sm"
                      variant="outline"
                      bg="white"
                      borderRadius="lg"
                      rightIcon={<ChevronLeftIcon />}
                      fontFamily="Tajawal, sans-serif"
                      fontWeight="600"
                    >
                      التالية
                    </Button>
                    <IconButton
                      icon={<ChevronLeftIcon />}
                      onClick={() => gotoPage(pageCount - 1)}
                      isDisabled={!canNextPage}
                      variant="outline"
                      bg="white"
                      borderRadius="lg"
                      aria-label="الصفحة الأخيرة"
                      size="sm"
                    />
                  </HStack>
                </Flex>
              </>
            )}
          </CardBody>
        </Card>
      </motion.div>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={!!deletingUser} onClose={() => setDeletingUser(null)} isCentered>
        <ModalOverlay bg="blackAlpha.700" backdropFilter="blur(8px)" />
        <ModalContent borderRadius="2xl" boxShadow="2xl" overflow="hidden" border="none">
          <Box h="6px" bg="red.500" />
          <ModalHeader pt={8} pb={2} textAlign="center" fontSize="xl" fontWeight="800" fontFamily="Tajawal, sans-serif" color={secondaryColor}>
            تأكيد حذف المستخدم
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody px={8} py={6}>
            <VStack spacing={6}>
              <Box p={5} bg="red.50" borderRadius="full" color="red.500">
                <Icon as={FiUserX} boxSize={12} />
              </Box>
              <VStack spacing={2}>
                <Text fontSize="lg" fontWeight="700" color={secondaryColor} textAlign="center" fontFamily="Tajawal, sans-serif">
                  هل أنت متأكد من حذف هذا المستخدم نهائياً؟
                </Text>
                <Text fontSize="sm" color="gray.500" textAlign="center" fontFamily="Tajawal, sans-serif" lineHeight="tall">
                  سيؤدي هذا الإجرء إلى مسح كافة البيانات المتعلقة بالمستخدم من النظام، بما في ذلك سجلات الحضور والمدفوعات. لا يمكن التراجع عن هذا الإجراء.
                </Text>
              </VStack>
            </VStack>
          </ModalBody>
          <ModalFooter bg="gray.50" px={8} py={6}>
            <HStack spacing={4} w="full">
              <Button
                flex={1}
                colorScheme="red"
                size="lg"
                borderRadius="xl"
                onClick={confirmDeleteUser}
                fontFamily="Tajawal, sans-serif"
                fontWeight="700"
                boxShadow="0 4px 12px rgba(229, 62, 62, 0.3)"
              >
                تأكيد الحذف النهائي
              </Button>
              <Button
                flex={1}
                variant="ghost"
                size="lg"
                borderRadius="xl"
                onClick={() => setDeletingUser(null)}
                fontFamily="Tajawal, sans-serif"
                fontWeight="600"
                _hover={{ bg: 'gray.200' }}
              >
                إلغاء
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>

      
      {/* Add/Edit User Modal */}
      <Modal isOpen={isOpen && !deletingUser} onClose={onClose} dir="rtl" size="3xl" scrollBehavior="inside">
        <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
        <ModalContent borderRadius="xl" fontFamily="Tajawal, sans-serif">
          <ModalHeader bg={secondaryColor} color="white" borderTopRadius="xl" py={4}>
            <Flex align="center" gap={3}>
              <Icon as={FiUserPlus} boxSize={6} />
              <Text>{selectedUser?._id ? 'تعديل بيانات المستخدم' : 'إضافة مستخدم جديد'}</Text>
            </Flex>
          </ModalHeader>
          <ModalCloseButton color="white" top={4} />
          <ModalBody p={6}>
            <Box>
              <Text fontSize="lg" fontWeight="bold" color={secondaryColor} mb={4}>المعلومات الأساسية</Text>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} mb={8}>
                <FormControl isInvalid={errorMessage.includes('الاسم')}>
                  <FormLabel color={textColor} fontWeight="600" fontFamily="Tajawal, sans-serif">
                    اسم المستخدم
                  </FormLabel>
                  <Input
                    placeholder="أدخل اسم المستخدم"
                    value={selectedUser?.name || ''}
                    onChange={(e) => setSelectedUser({ ...selectedUser, name: e.target.value })}
                    bg="gray.50"
                    border="2px solid"
                    borderColor="gray.200"
                    _focus={{
                      borderColor: primaryColor,
                      boxShadow: `0 0 0 1px ${primaryColor}`
                    }}
                    borderRadius="lg"
                  />
                </FormControl>

                <FormControl isInvalid={errorMessage.includes('البريد')}>
                  <FormLabel color={textColor} fontWeight="600" fontFamily="Tajawal, sans-serif">
                    البريد الإلكتروني
                  </FormLabel>
                  <Input
                    type="email"
                    placeholder="أدخل البريد الإلكتروني"
                    value={selectedUser?.email || ''}
                    onChange={(e) => setSelectedUser({ ...selectedUser, email: e.target.value })}
                    bg="gray.50"
                    border="2px solid"
                    borderColor="gray.200"
                    _focus={{
                      borderColor: primaryColor,
                      boxShadow: `0 0 0 1px ${primaryColor}`
                    }}
                    borderRadius="lg"
                  />
                </FormControl>

                <FormControl isInvalid={errorMessage.includes('الهاتف')}>
                  <FormLabel color={textColor} fontWeight="600" fontFamily="Tajawal, sans-serif">
                    رقم الهاتف
                  </FormLabel>
                  <Input
                    type="tel"
                    placeholder="أدخل رقم الهاتف"
                    value={selectedUser?.phoneNumber || ''}
                    onChange={(e) => setSelectedUser({ ...selectedUser, phoneNumber: e.target.value })}
                    bg="gray.50"
                    border="2px solid"
                    borderColor="gray.200"
                    _focus={{
                      borderColor: primaryColor,
                      boxShadow: `0 0 0 1px ${primaryColor}`
                    }}
                    borderRadius="lg"
                  />
                </FormControl>

                <FormControl>
                  <FormLabel color={textColor} fontWeight="600" fontFamily="Tajawal, sans-serif">
                    نوع الحساب
                  </FormLabel>
                  <Select
                    value={selectedUser?.role || 'student'}
                    onChange={(e) => setSelectedUser({ ...selectedUser, role: e.target.value })}
                    bg="gray.50"
                    border="2px solid"
                    borderColor="gray.200"
                    _focus={{
                      borderColor: primaryColor,
                      boxShadow: `0 0 0 1px ${primaryColor}`
                    }}
                    borderRadius="lg"
                  >
                    <option value="student">طالب</option>
                    <option value="instructor">مدرس</option>
                    <option value="admin">مدير</option>
                  </Select>
                </FormControl>

                <FormControl>
                  <FormLabel color={textColor} fontWeight="600" fontFamily="Tajawal, sans-serif">
                    تاريخ التسجيل
                  </FormLabel>
                  <Input
                    type="date"
                    value={selectedUser?.inscriptionDate ? new Date(selectedUser.inscriptionDate).toISOString().split('T')[0] : ''}
                    onChange={(e) => setSelectedUser({ ...selectedUser, inscriptionDate: e.target.value })}
                    bg="gray.50"
                    border="2px solid"
                    borderColor="gray.200"
                    _focus={{
                      borderColor: primaryColor,
                      boxShadow: `0 0 0 1px ${primaryColor}`
                    }}
                    borderRadius="lg"
                  />
                </FormControl>
              </SimpleGrid>

              <Divider my={6} borderColor="gray.200" />
              
              <Text fontSize="lg" fontWeight="bold" color={secondaryColor} mb={4}>معلومات التواصل الإضافية (للطلاب)</Text>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} mb={8}>
                <FormControl isInvalid={errorMessage.includes('ولي الأمر')}>
                  <FormLabel color={textColor} fontWeight="600" fontFamily="Tajawal, sans-serif">
                    رقم هاتف ولي الأمر
                  </FormLabel>
                  <Input
                    type="tel"
                    placeholder="أدخل رقم هاتف ولي الأمر"
                    value={selectedUser?.parentPhoneNumber || ''}
                    onChange={(e) => setSelectedUser({ ...selectedUser, parentPhoneNumber: e.target.value })}
                    bg="gray.50"
                    border="2px solid"
                    borderColor="gray.200"
                    _focus={{
                      borderColor: primaryColor,
                      boxShadow: `0 0 0 1px ${primaryColor}`
                    }}
                    borderRadius="lg"
                  />
                </FormControl>

                <FormControl>
                  <FormLabel color={textColor} fontWeight="600" fontFamily="Tajawal, sans-serif">
                    رقم واتساب التلميذ
                  </FormLabel>
                  <Input
                    type="tel"
                    placeholder="أدخل رقم واتساب التلميذ"
                    value={selectedUser?.whatsappNumberUser || ''}
                    onChange={(e) => setSelectedUser({ ...selectedUser, whatsappNumberUser: e.target.value })}
                    bg="gray.50"
                    border="2px solid"
                    borderColor="gray.200"
                    _focus={{
                      borderColor: primaryColor,
                      boxShadow: `0 0 0 1px ${primaryColor}`
                    }}
                    borderRadius="lg"
                  />
                </FormControl>

                <FormControl>
                  <FormLabel color={textColor} fontWeight="600" fontFamily="Tajawal, sans-serif">
                    رقم واتساب ولي أمر
                  </FormLabel>
                  <Input
                    type="tel"
                    placeholder="أدخل رقم واتساب ولي أمر"
                    value={selectedUser?.whatsappNumberParent || ''}
                    onChange={(e) => setSelectedUser({ ...selectedUser, whatsappNumberParent: e.target.value })}
                    bg="gray.50"
                    border="2px solid"
                    borderColor="gray.200"
                    _focus={{
                      borderColor: primaryColor,
                      boxShadow: `0 0 0 1px ${primaryColor}`
                    }}
                    borderRadius="lg"
                  />
                </FormControl>
              </SimpleGrid>

              <Divider my={6} borderColor="gray.200" />
              
              <Text fontSize="lg" fontWeight="bold" color={secondaryColor} mb={4}>المواد والمجموعات</Text>
              <VStack spacing={6} align="stretch" mb={8}>
                <FormControl>
                  <FormLabel color={textColor} fontWeight="600" fontFamily="Tajawal, sans-serif">
                    المواد الدراسية
                  </FormLabel>
                  <Box>
                    <ReactSelect
                      isMulti
                      options={matiersOptions}
                      placeholder="اختر المواد الدراسية"
                      value={(selectedUser?.matiers || []).map((el) => ({ label: el, value: el }))}
                      onChange={(selected) =>
                        setSelectedUser({
                          ...selectedUser,
                          matiers: selected ? selected.map((item) => item.value) : []
                        })
                      }
                      styles={{
                        control: (base) => ({
                          ...base,
                          textAlign: 'right',
                          borderColor: '#e2e8f0',
                          borderWidth: '2px',
                          borderRadius: '8px',
                          '&:hover': {
                            borderColor: primaryColor
                          }
                        }),
                        placeholder: (base) => ({ ...base, textAlign: 'right' }),
                        singleValue: (base) => ({ ...base, textAlign: 'right' }),
                        input: (base) => ({ ...base, textAlign: 'right' }),
                        multiValue: (base) => ({
                          ...base,
                          backgroundColor: `${primaryColor}20`,
                          borderRadius: '6px'
                        }),
                        multiValueLabel: (base) => ({
                          ...base,
                          color: secondaryColor,
                          fontFamily: 'Cairo, sans-serif'
                        })
                      }}
                    />
                  </Box>
                </FormControl>
              {/* Payment Information - For students */}
              {selectedUser?.role === 'student' && (
                <Box
                  bg="yellow.50"
                  border="2px solid"
                  borderColor="yellow.200"
                  borderRadius="lg"
                  p={4}
                  mt={2}
                >
                  <Text
                    fontWeight="700"
                    color={secondaryColor}
                    mb={4}
                    fontSize="lg"
                    fontFamily="Tajawal, sans-serif"
                  >
                    معلومات الدفع {existingPayment && '(موجود)'}
                  </Text>

                  {loadingPayment ? (
                    <Text textAlign="center" color="gray.500">جاري التحميل...</Text>
                  ) : (
                    <VStack spacing={4} align="stretch">
                      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                        <FormControl>
                          <FormLabel color={textColor} fontWeight="600" fontSize="sm">
                            المبلغ الإجمالي (TND)
                          </FormLabel>
                          <Input
                            type="number"
                            placeholder="3000"
                            value={paymentData.totalAmount}
                            onChange={(e) => {
                              setPaymentData({ ...paymentData, totalAmount: e.target.value });
                              calculateInstallments({ ...paymentData, totalAmount: e.target.value });
                            }}
                            bg="white"
                            border="2px solid"
                            borderColor="gray.200"
                            _focus={{ borderColor: primaryColor }}
                            borderRadius="lg"
                          />
                        </FormControl>

                        <FormControl>
                          <FormLabel color={textColor} fontWeight="600" fontSize="sm">
                            المبلغ المدفوع (TND)
                          </FormLabel>
                          <Input
                            type="number"
                            placeholder="1000"
                            value={paymentData.paidAmount}
                            onChange={(e) => {
                              setPaymentData({ ...paymentData, paidAmount: e.target.value });
                              calculateInstallments({ ...paymentData, paidAmount: e.target.value });
                            }}
                            bg="white"
                            border="2px solid"
                            borderColor="gray.200"
                            _focus={{ borderColor: primaryColor }}
                            borderRadius="lg"
                          />
                        </FormControl>
                      </SimpleGrid>

                      {paymentData.totalAmount && (
                        <Box
                          bg={primaryColor}
                          color={secondaryColor}
                          p={3}
                          borderRadius="lg"
                          textAlign="center"
                          fontWeight="700"
                        >
                          المبلغ المتبقي: {(parseFloat(paymentData.totalAmount) - (parseFloat(paymentData.paidAmount) || 0)).toFixed(2)} TND
                        </Box>
                      )}

                      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                        <FormControl>
                          <FormLabel color={textColor} fontWeight="600" fontSize="sm">
                            عدد الأقساط
                          </FormLabel>
                          <Input
                            type="number"
                            min="1"
                            value={paymentData.numberOfInstallments}
                            onChange={(e) => {
                              setPaymentData({ ...paymentData, numberOfInstallments: e.target.value });
                              calculateInstallments({ ...paymentData, numberOfInstallments: e.target.value });
                            }}
                            bg="white"
                            border="2px solid"
                            borderColor="gray.200"
                            _focus={{ borderColor: primaryColor }}
                            borderRadius="lg"
                          />
                        </FormControl>

                        <FormControl>
                          <FormLabel color={textColor} fontWeight="600" fontSize="sm">
                            تاريخ غلق الحساب (ان لم يتم تسديد معلوم التسجيل كاملا)
                          </FormLabel>
                          <Input
                            type="date"
                            value={paymentData.deadlineDate}
                            onChange={(e) => {
                              setPaymentData({ ...paymentData, deadlineDate: e.target.value });
                              calculateInstallments({ ...paymentData, deadlineDate: e.target.value });
                            }}
                            bg="white"
                            border="2px solid"
                            borderColor="gray.200"
                            _focus={{ borderColor: primaryColor }}
                            borderRadius="lg"
                          />
                        </FormControl>
                      </SimpleGrid>

                      {paymentData.customInstallments.length > 0 && (
                        <Box bg="white" p={3} borderRadius="lg" border="1px solid" borderColor="gray.200">
                          <Text fontWeight="600" color={textColor} mb={2} fontSize="sm">
                            إدارة الأقساط (Tranches):
                          </Text>
                          <VStack spacing={3} align="stretch">
                            {paymentData.customInstallments.map((inst, idx) => (
                              <Box key={idx} p={3} bg="gray.50" borderRadius="md">
                                <Flex justify="space-between" align="end" gap={2}>
                                  <VStack align="start" flex="1">
                                    <Text fontSize="xs" fontWeight="bold">المبلغ (القسط {idx + 1})</Text>
                                    <Input
                                      size="sm"
                                      type="number"
                                      value={inst.amount}
                                      onChange={(e) => handleCustomInstallmentChange(idx, 'amount', e.target.value)}
                                      bg="white"
                                    />
                                  </VStack>
                                  <VStack align="start" flex="1">
                                    <Text fontSize="xs" fontWeight="bold">تاريخ الدفع</Text>
                                    <Input
                                      size="sm"
                                      type="date"
                                      value={inst.dueDate}
                                      onChange={(e) => handleCustomInstallmentChange(idx, 'dueDate', e.target.value)}
                                      bg="white"
                                    />
                                  </VStack>
                                  <Flex direction="column" align="center" gap={1}>
                                    <Badge colorScheme={inst.isPaid ? 'green' : 'orange'}>
                                      {inst.isPaid ? 'مدفوع' : 'معلق'}
                                    </Badge>
                                    {selectedUser && inst._id && !inst.isPaid && (
                                      <Button
                                        size="xs"
                                        colorScheme="green"
                                        onClick={() => handleMarkInstallmentAsPaid(inst._id)}
                                        fontSize="10px"
                                        h="20px"
                                      >
                                        Payé
                                      </Button>
                                    )}
                                  </Flex>
                                </Flex>
                              </Box>
                            ))}
                          </VStack>
                        </Box>
                      )}
                    </VStack>
                  )}
                </Box>
              )}

              {/* Group Assignments for Students */}
              {selectedUser?.role === 'student' && selectedUser?.matiers?.map((matier, idx) => {
                // Find groups with case-insensitive matching
                const attendanceGroupSet = attendanceGroups.find(g =>
                  g.matier?.toLowerCase().trim() === matier?.toLowerCase().trim()
                );
                const availableGroups = attendanceGroupSet?.groups || [];

                // Find existing assignment with case-insensitive matching
                const currentAssignment = studentGroupAssignments.find(a =>
                  a.matier?.toLowerCase().trim() === matier?.toLowerCase().trim()
                );
                const selectedGroups = (currentAssignment?.groupNames || []).map(g => ({ label: g, value: g }));

                return (
                  <FormControl key={idx}>
                    <FormLabel color={textColor} fontWeight="600" fontFamily="Tajawal, sans-serif">
                      المجموعات لـ {matier} {availableGroups.length === 0 && '(لا توجد مجموعات معرفة)'}
                    </FormLabel>
                    <Box dir="rtl">
                      <ReactSelect
                        instanceId={`select-groups-${idx}`}
                        isMulti
                        options={availableGroups.map(g => ({ label: g, value: g }))}
                        placeholder={availableGroups.length > 0 ? "اختر المجموعات" : "لا توجد مجموعات متاحة"}
                        value={selectedGroups}
                        menuPortalTarget={document.body}
                        onChange={async (selected) => {
                          const groupNames = selected ? selected.map((item) => item.value) : [];
                          try {
                            await attendanceService.assignStudentToGroup({
                              studentId: selectedUser._id,
                              matier,
                              groupNames
                            });
                            fetchStudentGroups(selectedUser._id);
                            toast({ title: 'تم تحديث المجموعات بنجاح', status: 'success' });
                          } catch (err) {
                            toast({ title: 'خطأ في تحديث المجموعات', status: 'error' });
                          }
                        }}
                        styles={{
                          control: (base) => ({
                            ...base,
                            textAlign: 'right',
                            borderColor: '#e2e8f0',
                            borderWidth: '2px',
                            borderRadius: '8px',
                            minHeight: '45px',
                            '&:hover': {
                              borderColor: primaryColor
                            }
                          }),
                          placeholder: (base) => ({ ...base, textAlign: 'right' }),
                          singleValue: (base) => ({ ...base, textAlign: 'right' }),
                          input: (base) => ({ ...base, textAlign: 'right' }),
                          menu: (base) => ({ ...base, textAlign: 'right', zIndex: 9999 }),
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          multiValue: (base) => ({
                            ...base,
                            backgroundColor: `${primaryColor}20`,
                            borderRadius: '6px'
                          }),
                          multiValueLabel: (base) => ({
                            ...base,
                            color: secondaryColor,
                            fontFamily: 'Cairo, sans-serif'
                          })
                        }}
                      />
                    </Box>
                  </FormControl>
                );
              })}

              {errorMessage && (
                <Alert status="error" borderRadius="lg">
                  <AlertIcon />
                  <AlertDescription fontFamily="Tajawal, sans-serif">
                    {errorMessage}
                  </AlertDescription>
                </Alert>
              )}
            </VStack>
            </Box>
          </ModalBody>
          <ModalFooter bg="gray.50" borderBottomRadius="xl">
            <HStack spacing={3}>
              <Button
                bg={primaryColor}
                color={secondaryColor}
                _hover={{ bg: '#d4b016' }}
                onClick={handleSaveUser}
                isLoading={loading}
                loadingText="جاري الحفظ..."
                fontFamily="Tajawal, sans-serif"
              >
                {selectedUser?._id ? 'حفظ التغييرات' : 'إضافة المستخدم'}
              </Button>
              <Button
                variant="ghost"
                onClick={onClose}
                fontFamily="Tajawal, sans-serif"
              >
                إلغاء
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Statistics Modal */}
      <NewPopupModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        userdata={StatUser}
      />

      {/* Send Email Modal */}
      <TextSubmitPopup
        isOpen={isEmailModalOpen}
        onClose={() => setIsEmailModalOpen(false)}
        users={filteredUsers}
      />

      {/* Attendance History Modal */}
      <Modal isOpen={isAbsenceModalOpen} onClose={() => setIsAbsenceModalOpen(false)} size="xl">
        <ModalOverlay />
        <ModalContent dir="rtl">
          <ModalHeader fontFamily="Tajawal, sans-serif">سجل حضور الطالب - {selectedUser?.username}</ModalHeader>
          <ModalCloseButton left="8px" right="auto" />
          <ModalBody>
            <Box overflowX="auto">
              <Table variant="simple" size={{ base: "sm", md: "md" }}>
                <Thead>
                  <Tr>
                    <Th fontFamily="Tajawal, sans-serif">التاريخ</Th>
                    <Th fontFamily="Tajawal, sans-serif">المادة</Th>
                    <Th fontFamily="Tajawal, sans-serif">الحصة</Th>
                    <Th fontFamily="Tajawal, sans-serif">الحالة</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {studentAbsences.map((abs, i) => (
                    <Tr key={i}>
                      <Td fontSize={{ base: "xs", md: "sm" }}>{new Date(abs.date).toLocaleDateString('fr-FR')}</Td>
                      <Td fontSize={{ base: "xs", md: "sm" }}>{abs.matier}</Td>
                      <Td fontSize={{ base: "xs", md: "sm" }}>{abs.lessonTitle}</Td>
                      <Td>
                        <Badge size="sm" colorScheme={abs.status === 'present' ? 'green' : 'red'}>
                          {abs.status === 'present' ? 'حاضر' : 'غائب'}
                        </Badge>
                      </Td>
                    </Tr>
                  ))}
                  {studentAbsences.length === 0 && (
                    <Tr><Td colSpan={4} textAlign="center" fontFamily="Tajawal, sans-serif">لا توجد سجلات حضور مسجلة.</Td></Tr>
                  )}
                </Tbody>
              </Table>
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => setIsAbsenceModalOpen(false)} fontFamily="Tajawal, sans-serif">إغلاق</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <AlertManagementModal
        isOpen={isAlertModalOpen}
        onClose={() => setIsAlertModalOpen(false)}
      />

      <UserDetailsDrawer
        user={viewedUser}
        isOpen={!!viewedUser}
        onClose={() => setViewedUser(null)}
      />

      <SendSMSModal
        isOpen={isSMSModalOpen}
        onClose={() => setIsSMSModalOpen(false)}
        users={users}
        attendanceGroups={attendanceGroups}
      />

      {isCreateUserPopupOpen && (
        <CreateUserFromRegistrationModal
          isOpen={isCreateUserPopupOpen}
          onClose={() => setIsCreateUserPopupOpen(false)}
          onSuccess={fetchUsers}
        />
      )}

      {selectedPaymentRecord && (
        <PaymentDetailsModal
          payment={selectedPaymentRecord}
          onClose={() => setSelectedPaymentRecord(null)}
          onUpdate={fetchUsers}
        />
      )}
    </Box >

  );
};

export default UserAdminManagement;
